import { FETCH_LIST, RESET_DATA, SEND_EVENT, SET_DATA } from 'modules/Stories/store/types'

export const actionFetchList = (props) => ({
  type: FETCH_LIST,
  payload: props,
})

export const actionSendEvent = (props) => ({
  type: SEND_EVENT,
  payload: props,
})

export const actionSetData = (props) => ({
  type: SET_DATA,
  payload: props,
})

export const actionResetData = () => ({
  type: RESET_DATA,
})
